import { InputLabel, createStyles, makeStyles, withStyles } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { red } from '@material-ui/core/colors';

type SelectDropdownProps = {
    value: any,
    options: Array<any>,
    id: string,
    label: any,
    onChange: (event: any, newInputValue: any, reason?: any) => void,
    disabled?: boolean
}


const useStyles = makeStyles((theme: any) =>
    createStyles({

        root: {
            '& legend': {
                display: 'none',
            },
            '& label.Mui-focused': {
                color: 'white',
            },
            '& .MuiInput-underline:after': {
                borderBottomColor: 'yellow',
            },
            '& .MuiOutlinedInput-root': {
                '& input': {
                    zIndex: '999'
                },
                '& fieldset': {
                    borderColor: '#ccc',
                },
                '&:hover fieldset': {
                    borderColor: '#ccc',
                },
                '&.Mui-focused fieldset': {
                    borderColor: '#ccc',
                    borderWidth: '1px'
                },
            },
        },

        formControl: {
            margin: theme.spacing(1),
            minWidth: 50,
        },
        selectEmpty: {
            marginTop: theme.spacing(1),
        },
    }),
);



export const SelectDropdown = (props: SelectDropdownProps) => {

    const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
        props.onChange(event, event.target.value as string);
    };

    const classes = useStyles();

    return (
        <FormControl variant="outlined" className={classes.formControl}>
            <Select
                labelId="demo-simple-select-outlined-label"
                id={props.id}
                value={props.value}
                onChange={handleChange}
                label={props.label}

            >
                {props.options.map((item: any, index: number) => {
                    return (<MenuItem value={item}>{item}</MenuItem>)
                })}
            </Select>
        </FormControl>
    )
}

